import "../styles/HeaderHomeOut.css";
import condicionesGenerales from "../../../../assets/docs/Condiciones Generales.pdf";
import SidebarActivarCuenta from "../../../../components/sidebar/SidebarActivarCuenta";
import { useEffect, useState } from "react";

const HeadHomeOut = ({
  infoApi,
  setMostrarLogin,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
  setLoading,
}) => {
  const downloadCondicionesGenerales = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = condicionesGenerales;
    downloadLink.download = "Condiciones Generales.pdf";
    downloadLink.click();
  };

  const [mostrarModalActivarCuenta, setMostrarModalActivarCuenta] =
    useState(false);
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");

  const openActivarCuenta = () => {
    setMostrarModalActivarCuenta(true);
  };

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [infoApi]);

  return (
    <>
      <SidebarActivarCuenta
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={mostrarModalActivarCuenta}
        setShow={setMostrarModalActivarCuenta}
        setShowLogin={setMostrarLogin}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />
      <div className="container-fluid banner pe-0 ps-0 d-block d-lg-none">
        {/* <div className="container-xxl pe-0 ps-0"> */}
        <div className="row me-0">
          <div className="col-12 col-md-6 pt-lg-4 pe-0">
            <div style={{ backgroundColor: "#84D9C6"}}>
              <img
                src="/assets/img/homeout/img-banner-homeoutheader.jpg"
                className="banner__image d-block d-md-none"
                alt=""
              />
            </div>
            <div className="banner__text__center">
              <h5 className="banner__title">
                <b>¡Bienvenido!</b>
              </h5>
              <p className="banner__text pe-3 mt-3 pb-3">
                Conoce todo lo relacionado con tu
                seguro <b className="bold">Protección de Ingresos</b>, el cual
                te protege ante eventos de vida, desempleo e invalidez total
                permanente. 
              </p>
              <button
                className="banner__button"
                onClick={downloadCondicionesGenerales}
              >
                DESCARGAR CONDICIONES GENERALES
              </button>
              <button
                className="banner__button_activarbeneficios"
                onClick={openActivarCuenta}
              >
                ACTIVAR BENEFICIOS
              </button>
            </div>

            <div className="banner__footer align-items-center d-flex d-md-none">
              <div className="cps-5 banner__footer__text pe-3">
                <p>
                  Llama sin costo: {" "}
                  <span>
                    <b>
                      <a
                        href="tel:8008012402"
                        style={{ fontFamily: "var(--fuente-bold)" }}
                      >
                        800 801 2402
                      </a>
                    </b>
                  </span>
                </p>
                <p>
                  Horarios: Lun - vie de 08:00 a 21:00
                  hrs.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-none d-md-block pe-lg-0">
            <img
              src="/assets/img/homeout/img-banner-homeoutheader.jpg"
              className="banner__image"
              alt=""
            />
          </div>
        </div>

        <div
          className="row banner__footer d-none d-md-flex ms-0 me-0"
          style={{ backgroundColor: "#F7F7F7", color: "#000000" }}
        >
          <div className="col-12">
            <div className="row align-items-center justify-content-center">
              <div
                className="col-9 ps-5 banner__footer__text justify-content-center"
              >
                <p className="">
                  Llama sin costo: {" "}
                  <span className="ps-3 pe-3">
                    <b>
                      <a
                        href="tel:8008012402"
                        style={{ fontFamily: "var(--fuente-bold)" }}
                      >
                        800 801 2402
                      </a>
                    </b>
                  </span>
                </p>
                <p className="pe-3">
                  Horarios: Lunes a viernes de 08:00 a 21:00 hrs.
                </p>
                <p></p>
                <p></p>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      <div className="home p-0 d-none d-lg-block">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-back">
              <div className="home__text-container">
                <div className="home__title mb-5">
                  <h2>¡Bienvenido!</h2>
                </div>

                <div className="home__text mb-0">
                  <p className="mb-0" style={{ lineHeight: "1.2" }}>
                    Conoce todo lo relacionado con tu seguro <br/>
                    <b className="bold">Protección de Ingresos</b>, el cual te protege ante <br/>
                    eventos de vida, desempleo e invalidez. 
                  </p>
                </div>
                <button
                  className="btn__azul"
                  style={{ width: "330px", padding: "1rem 2rem" }}
                  onClick={downloadCondicionesGenerales}
                >
                  DESCARGAR CONDICIONES GENERALES
                </button>
                <button
                  className="btn__activarbeneficios mt-5"
                  style={{ width: "330px", padding: "1rem 2rem" }}
                  onClick={openActivarCuenta}
                >
                  ACTIVAR BENEFICIOS
                </button>
              </div>
            </div>

            <div className="col-12 col-md-6 col-image p-0">
              <div className="home__image-container">
                <img
                  src="/assets/img/homeout/img-banner-homeoutheader.jpg"
                  className="home__image_desks"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="head__footer d-none d-lg-grid">
        <p>
          {" "}
          Llama sin costo:
          <span style={{ fontFamily: "var(--fuente-bold)" }}>
            <b> 800 801 2402</b>
          </span>
        </p>
        <div className="separacion d-none d-lg-inline"></div>
        <p>Horarios: Lunes a viernes de 08:00 a 21:00 hrs.</p>
      </div>
    </>
  );
};

export default HeadHomeOut;
